import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-screen" }

import LandingHeader from '@/features/landing/components/LandingHeader.vue'
import LandingFooter from '@/features/landing/components/LandingFooter.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LandingLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LandingHeader),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(LandingFooter, { class: "mt-auto" })
  ]))
}
}

})